import { ROLES } from 'constants/roles';
import { CONTENT_TYPES } from 'constants/playlists';

export const validateRole = ({ roles = [] }: { roles: string[]; email?: string }): boolean => {
  const accountManagementRole = [ROLES.ADMIN, ROLES.SALES, ROLES.SUPPORT, ROLES.DATA_MANAGER].some(
    (item) => roles.includes(item)
  );
  return accountManagementRole;
};

export const validateAccountOwner = (roles: string[] = []): boolean =>
  roles.includes(ROLES.ACCOUNT_OWNER);
export const validateTeamManager = (roles: string[] = []): boolean =>
  roles.includes(ROLES.TEAM_MANAGER);

export const isTeamManagerOrAccountOwner = (roles: string[] = []): boolean =>
  validateTeamManager(roles) || validateAccountOwner(roles);

// A Team Manager limited to the teams they manage: not also an Account Owner or staff.
export const isTeamScopedManager = ({
  isTeamManager,
  isAccountOwner,
  isStaff,
}: {
  isTeamManager?: boolean;
  isAccountOwner?: boolean;
  isStaff?: boolean;
}): boolean => Boolean(isTeamManager && !isAccountOwner && !isStaff);

export const isStaffMember = (roles: string[] = []): boolean =>
  roles.some((item) => [ROLES.STAFF, ROLES.ADMIN, ROLES.SALES, ROLES.SUPPORT].includes(item));

export const isDataManager = (roles: string[] = []): boolean => roles.includes(ROLES.DATA_MANAGER);

export const findRoles = (rolesToFind: string[], userRoleIds: string[] = []): boolean =>
  rolesToFind.some((userRoleId) => userRoleIds.includes(userRoleId));

// Shared by session `hasSkillDive` and `useAccountPlanData().skillDive` so the two can't disagree.
// Matches on `name` because catalog ids differ per environment; only an explicit
// `plan_eligible: false` counts as not on the plan.
export const hasSkillDiveAddon = (
  account?: { account_available_addons?: { name: string; plan_eligible?: boolean }[] | null } | null
): boolean =>
  Boolean(
    account?.account_available_addons?.some(
      (addon) => addon.name === CONTENT_TYPES.SKILL_DIVE && addon.plan_eligible !== false
    )
  );
